// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#cabecalho[data-v-03c69ff7]{font-weight:700}@media print{#cabecalho[data-v-03c69ff7]{font-weight:700}}", ""]);
// Exports
module.exports = exports;
